'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _roleCategories = require('../actions/roleCategories');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchRoleCategories),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchRoleCategoriesRequest);

function fetchRoleCategories() {
    var response;
    return regeneratorRuntime.wrap(function fetchRoleCategories$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/rolecategories');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_roleCategories.actionCreators.fetchRoleCategoriesSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_roleCategories.actionCreators.fetchRoleCategoriesFailed());

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchRoleCategoriesRequest() {
    return regeneratorRuntime.wrap(function fetchRoleCategoriesRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_roleCategories.actionTypes.FETCH_ROLE_CATEGORIES_REQUEST, fetchRoleCategories);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

exports.default = [fetchRoleCategoriesRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/roleCategories.js
// module id = 2231
// module chunks = 0